import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface FacilityLogin {
  username: string;
  password: string;
}

export interface FacilityLoginResponse {
  userId: number;
  facilityId: number;
  facilityName: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  status: string;
  passwordChangeRequired: boolean;
  requiredMfa: boolean;
  mfaScanRequired: boolean;
  accessToken: string;
  isWaitingRoom: boolean;
  consultId: number;
  isAssociatedFacilityInactive: boolean;
  isErrorPage: boolean;
  errorType: string;
}

export interface ForgotPassword {
  username: string;
  email: string;
}

export interface ResetPassword {
  userId: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ChangePassword {
  userId: number;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface FacilityResponce {
  code: number;
  status: string;
  message: string;
}

export interface EmailExpireResponce {
  code: number;
  status: string;
  message: string;
  valid: boolean;
}

export const getLogin = async (
  payload: FacilityLogin
): Promise<FacilityLoginResponse> => {
  const response = await httpRequest<FacilityLoginResponse>({
    url: `/facility/user/login`,
    method: 'POST',
    withCredentials: true,
    data: payload,
  });
  return response;
};

export const forgotPasswordEmail = async (payload: ForgotPassword) => {
  const response = await httpRequest<FacilityResponce>({
    url: `/facility/user/forgot-password/email`,
    method: 'POST',
    data: payload,
  });
  return response;
};

export const resetPassword = async (payload: ResetPassword) => {
  const response = await httpRequest<FacilityResponce>({
    url: `/facility/user/case-manager/reset-password`,
    method: 'POST',
    data: payload,
  });
  return response;
};

export const changePassword = async (payload: ChangePassword) => {
  const response = await httpRequest<FacilityResponce>({
    url: `/facility/user/case-manager/change-password`,
    method: 'POST',
    data: payload,
  });
  return response;
};

export const checkEmailExpire = async (token: string) => {
  const response = await httpRequest<EmailExpireResponce>({
    url: `/facility/user/password-reset-tokens/${token}/validate`,
    method: 'GET',
  });
  return response;
};
